import React from 'react'

const DotsLoader = ({ styles }) => {
    return(
        <div className="dotsloader" style={ styles }>
            <div className="dotloader"></div>
            <div className="dotloader"></div>
            <div className="dotloader"></div>
        </div>
    )
}

export default DotsLoader



// WEBPACK FOOTER //
// ./src/lib/dotsloader.js